
export class DataTransferObject {
  message: string = '';
}
